export default "__VITE_ASSET__B4Cq998m__"